export type MedalTier = 'bronze' | 'silver' | 'gold' | 'platinum' | 'none';

export type MedalLedger = {
  bronze: number;
  silver: number;
  gold: number;
  platinum: number;
  recordedTopicIds: string[];
};

const STORAGE_VERSION = 'v1';

function storageKey(userId: string) {
  return `centumth_medals_${STORAGE_VERSION}_${userId}`;
}

export function medalTierFromScore(score: number): MedalTier {
  if (score === 490) return 'platinum';
  if (score >= 300) return 'gold';
  if (score >= 150) return 'silver';
  if (score >= 50) return 'bronze';
  return 'none';
}

function emptyLedger(): MedalLedger {
  return { bronze: 0, silver: 0, gold: 0, platinum: 0, recordedTopicIds: [] };
}

export function getMedalLedger(userId: string): MedalLedger {
  if (typeof window === 'undefined') return emptyLedger();
  try {
    const raw = window.localStorage.getItem(storageKey(userId));
    if (!raw) return emptyLedger();
    const parsed = JSON.parse(raw) as Partial<MedalLedger> | null;
    if (!parsed || typeof parsed !== 'object') return emptyLedger();
    return {
      bronze: Number(parsed.bronze ?? 0) || 0,
      silver: Number(parsed.silver ?? 0) || 0,
      gold: Number(parsed.gold ?? 0) || 0,
      platinum: Number(parsed.platinum ?? 0) || 0,
      recordedTopicIds: Array.isArray(parsed.recordedTopicIds) ? parsed.recordedTopicIds.filter((x) => typeof x === 'string') : [],
    };
  } catch {
    return emptyLedger();
  }
}

export function recordMedalForTopic(userId: string, topicId: string, score: number): MedalLedger {
  if (typeof window === 'undefined') return emptyLedger();
  if (!userId || !topicId) return getMedalLedger(userId);

  const tier = medalTierFromScore(score);
  const ledger = getMedalLedger(userId);

  if (ledger.recordedTopicIds.includes(topicId)) return ledger;

  const next: MedalLedger = {
    ...ledger,
    recordedTopicIds: [...ledger.recordedTopicIds, topicId],
  };

  if (tier === 'bronze') next.bronze += 1;
  if (tier === 'silver') next.silver += 1;
  if (tier === 'gold') next.gold += 1;
  if (tier === 'platinum') next.platinum += 1;

  try {
    window.localStorage.setItem(storageKey(userId), JSON.stringify(next));
  } catch {
    // ignore write failures (private mode, quota, etc.)
  }

  return next;
}





